import { useCallback, useEffect, useState } from 'react'
import {
  WebPushState, disableWebPush, enableWebPush, onWebPushChange, webPushState
} from './webPush'

export default function useWebPush() {
  const [state, setState] = useState<WebPushState | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    let active = true
    const refresh = () => webPushState().then((next) => active && setState(next))
    refresh()
    const stop = onWebPushChange(refresh)
    return () => {
      active = false
      stop()
    }
  }, [])

  const run = useCallback(async (action: () => Promise<WebPushState>) => {
    setBusy(true)
    try {
      setState(await action())
    } finally {
      setBusy(false)
    }
  }, [])

  return {
    state,
    busy,
    enable: useCallback(() => run(enableWebPush), [run]),
    disable: useCallback(() => run(disableWebPush), [run])
  }
}
